import classNames from 'classnames';

import FormError from './FormError';

const RadioButton = (props) => {
  const {
    input,
    label,
    id,
    meta: { touched, error },
    noLabel = false
  } = props;
  const newId = id || `c7-radio${input.name}-${input.value}`;
  if (noLabel) {
    return (
      <input
        type="radio"
        id={newId}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...input}
        value={input.value}
        checked={input.checked}
      />
    );
  }
  return (
    <div className={classNames(touched && error && 'c7-error')}>
      <label htmlFor={`c7-radio${input.name}-${input.value}`} className="radio">
        <input
          type="radio"
          id={newId}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...input}
          value={input.value}
          checked={input.checked}
        />
        {label}
      </label>
      <FormError touched={touched} error={error} id={`${id}-error`} />
    </div>
  );
};

export default RadioButton;
